import { useGetQuery } from "slices/api";
import { ACCESS_APPLICATION } from "tagTypes";

export const useGetAccessCardApplicationStatusQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/uta-card-issuance-status",
    query,
    tags: [ACCESS_APPLICATION],
  });

export const useGetAccessCardApplicationDetailQuery = (
  applicationId,
  query = {}
) =>
  useGetQuery({
    endpoint: `/access-detail/${applicationId}`,
    query,
    tags: [ACCESS_APPLICATION],
  });
